import {
  FILTERPUSH_SET_CLOSED,
  FILTERPUSH_SET_OPEN,
} from '../actions/filter-push';

const initialState = {
  isOpen: false,
};

// TODO
export default (
  state = initialState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action: Record<string, any>
): FilterPushState => {
  switch (action.type) {
    case FILTERPUSH_SET_OPEN:
      return { isOpen: true };
    case FILTERPUSH_SET_CLOSED:
      return { isOpen: false };
    default:
      return state;
  }
};

export type FilterPushState = Record<string, boolean>;
